import React, { useState, useEffect } from 'react';
import { db, auth } from '../../firebase';
import { collection, addDoc, serverTimestamp, doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiSend, FiCheckCircle, FiMessageSquare } from 'react-icons/fi';

const FeedbackPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [clubName, setClubName] = useState('');

  const [formData, setFormData] = useState({
    category: 'Versenyiroda - Nevezés',
    description: ''
  });

  useEffect(() => {
    const fetchClubData = async () => {
      const user = auth.currentUser;
      if (!user) {
        navigate('/');
        return;
      }

      try {
        const clubDoc = await getDoc(doc(db, 'Clubs', user.uid));
        if (clubDoc.exists()) {
          setClubName(clubDoc.data().clubName || 'Ismeretlen Egyesület');
        }
      } catch (err) {
        console.error("Error fetching club data:", err);
      }
    };

    fetchClubData();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.description.trim()) {
      alert("Kérjük, írd le a problémát vagy észrevételt!");
      return;
    }

    setLoading(true);
    try {
      const user = auth.currentUser;
      await addDoc(collection(db, 'feedback'), {
        userId: user.uid,
        userEmail: user.email,
        clubName: clubName,
        category: formData.category,
        description: formData.description,
        createdAt: serverTimestamp(),
        status: 'new',
        platform: 'web'
      });

      setSuccess(true);
      setTimeout(() => {
        navigate('/egyesulet-dashboard');
      }, 2500);
    } catch (err) {
      console.error("Error saving feedback:", err);
      alert("Hiba történt a küldés során. Kérjük, próbáld újra később!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={containerStyle} className="force-light-theme">
      {/* SIKER MODAL */}
      {success && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <FiCheckCircle size={50} color="#28a745" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Köszönjük!</h3>
            <p style={{ color: '#666', marginBottom: '10px' }}>
              Visszajelzésedet sikeresen rögzítettük.
            </p>
            <p style={{ color: '#888', fontSize: '0.9rem' }}>
              Hamarosan visszatérsz az Irányítópultra...
            </p>
          </div>
        </div>
      )}

      <div style={headerStyle}>
        <button style={backButtonStyle} onClick={() => navigate('/egyesulet-dashboard')}>
          <FiArrowLeft size={24} />
        </button>
        <h1 style={titleStyle}>Hibajelentés / Visszajelzés</h1>
      </div>

      <div style={cardStyle}>
        <p style={introTextStyle}>
          Észrevételed van, vagy hibát találtál? Kérjük, oszd meg velünk, hogy fejleszthessük a rendszert!
        </p>

        <form onSubmit={handleSubmit}>
          {/* KATEGÓRIA */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Melyik résszel kapcsolatos?</label>
            <select
              value={formData.category}
              onChange={(e) => setFormData({ ...formData, category: e.target.value })}
              style={inputStyle}
              required
            >
              <option value="Versenyiroda - Nevezés">Versenyiroda - Nevezés</option>
              <option value="Versenyiroda - Csapatbeosztás">Versenyiroda - Csapatbeosztás</option>
              <option value="Versenyiroda - QR kód olvasás">Versenyiroda - QR kód olvasás</option>
              <option value="Versenyiroda - Eredmények">Versenyiroda - Eredmények</option>
              <option value="Versenyiroda - Áttekintés">Versenyiroda - Áttekintés</option>
              <option value="Irányítópult">Irányítópult</option>
              <option value="Irányítópult - verseny létrehozása/szerkesztése">Irányítópult - verseny létrehozása/szerkesztése</option>
              <option value="Versenylista / Kezdőlap">Versenylista / Kezdőlap</option>
              <option value="Profil kezelés">Profil kezelés</option>
              <option value="Egyéb / Általános észrevétel">Egyéb / Általános észrevétel</option>
            </select>
          </div>

          {/* LEÍRÁS */}
          <div style={inputGroupStyle}>
            <label style={labelStyle}>Részletes leírás</label>
            <textarea
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              placeholder="Kérjük, írd le részletesen, hogy mi történt, vagy mi a javaslatod..."
              style={textAreaStyle}
              required
            />
          </div>

          <div style={infoBoxStyle}>
            <FiMessageSquare size={20} color="#b30000" style={{ flexShrink: 0 }} />
            <span style={{ fontSize: '0.85rem', color: '#666' }}>
              A beküldéssel az e-mail címed és az egyesületed neve is továbbításra kerül, hogy felvehessük veled a kapcsolatot a megoldás érdekében.
            </span>
          </div>

          <button
            type="submit"
            disabled={loading || success}
            style={{ ...submitButtonStyle, opacity: loading ? 0.7 : 1 }}
          >
            {loading ? 'Küldés folyamatban...' : <><FiSend style={{ marginRight: '8px' }} /> Elküldés</>}
          </button>
        </form>
      </div>
    </div>
  );
};

// --- STÍLUSOK ---
const containerStyle = {
  padding: '2rem',
  maxWidth: '800px',
  margin: '0 auto',
  fontFamily: 'Arial, sans-serif',
  minHeight: '100vh',
  backgroundColor: '#f8f9fa'
};

const headerStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '15px',
  marginBottom: '2rem'
};

const backButtonStyle = {
  background: 'none',
  border: 'none',
  color: '#333',
  cursor: 'pointer',
  padding: '5px',
  display: 'flex',
  alignItems: 'center'
};

const titleStyle = {
  fontSize: '1.8rem',
  margin: 0,
  color: '#333',
  fontWeight: 'bold'
};

const cardStyle = {
  backgroundColor: '#fff',
  borderRadius: '16px',
  padding: '2.5rem',
  boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
};

const introTextStyle = {
  color: '#666',
  marginBottom: '2rem',
  lineHeight: '1.5'
};

const inputGroupStyle = {
  marginBottom: '1.5rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px'
};

const labelStyle = {
  fontSize: '0.85rem',
  fontWeight: 'bold',
  color: '#b30000',
  textTransform: 'uppercase'
};

const inputStyle = {
  width: '100%',
  padding: '12px 15px',
  borderRadius: '10px',
  border: '1px solid #ddd',
  fontSize: '1rem',
  boxSizing: 'border-box',
  outline: 'none',
  backgroundColor: '#fff'
};

const textAreaStyle = {
  ...inputStyle,
  minHeight: '200px',
  resize: 'vertical',
  lineHeight: '1.5'
};

const infoBoxStyle = {
  display: 'flex',
  gap: '12px',
  alignItems: 'center',
  padding: '15px',
  backgroundColor: '#fff5f5',
  borderRadius: '10px',
  marginBottom: '2rem',
  border: '1px solid #ffebeb'
};

const submitButtonStyle = {
  width: '100%',
  backgroundColor: '#b30000',
  color: '#fff',
  border: 'none',
  padding: '16px',
  borderRadius: '12px',
  fontWeight: 'bold',
  fontSize: '1.1rem',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'background 0.2s',
  boxShadow: '0 4px 12px rgba(179,0,0,0.2)'
};

const modalOverlayStyle = {
  position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
  backgroundColor: 'rgba(0,0,0,0.7)', display: 'flex', justifyContent: 'center',
  alignItems: 'center', zIndex: 2000, backdropFilter: 'blur(5px)'
};

const modalContentStyle = {
  backgroundColor: '#fff', padding: '40px', borderRadius: '20px',
  textAlign: 'center', maxWidth: '400px', width: '90%',
  boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
};

export default FeedbackPage;
